import { Component, NgZone } from '@angular/core';

import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';
import { BlockingtimeData } from '../../providers/blockingtime-data';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { AlertController } from 'ionic-angular';

@Component({
  selector: 'blockingtime-detail',
  templateUrl: 'blockingtime-detail.html'
})
export class BlockingtimeDetailPage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  oSelectedBlockingtime;

  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , private alertCtrl: AlertController
            , private blockingtimeData: BlockingtimeData
            ) {
    //let selectedpp = navParams.get('pp');
    
    this.init();
    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oSelectedBlockingtime = navParams.data;
    //console.log(this.oSelectedBlockingtime);

   }

   init(){
  

   }

   confirmStorno(kont){
     let title = "";
     let param: any;
      
      if(Array.isArray(kont)){
        title = "Soll die Kontrolle wirklich storniert werden?";
        param = kont;
        
      }
      else{
        title = "Soll die Kontrolle des Parkplatzes '"+kont.kurzname+"' wirklich storniert werden?";
        param = {pp1 : kont};
      }
     
      let alert = this.alertCtrl.create();
      alert.setTitle(title);
      alert.setSubTitle('Grund:');
      alert.addInput({
          type: 'textarea',
          label: 'Grund',
          
      });

      alert.addButton('Abbrechen');
      alert.addButton({
        text: 'Ja',
        handler: (data: any) => {
            this.stornoBlockingtime(param, data[0]);
            //this.testCheckboxOpen = false;
        }
      });

      alert.present();
      
   }

   stornoBlockingtime(kont,reason){
       
        Promise.all([
            //this.blockingtimeData.sotrno(kont, reason),            
          ]).then(data => {
            //console.log(data);
            //this.blockingtime = this.blockingtimeData.data;      
            this.navCtrl.pop();
          });   
   }

  
}



// WEBPACK FOOTER //
// ./src/pages/blockingtime/blockingtime-detail.ts